import React from 'react';
import "./testimonials.css";

const Testimonials = () => {
    return (
        <div>
            <h1></h1>
        </div>
    )
}
export default Testimonials